import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Box, Grid } from "@mui/material";
import "../App.css";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { GoogleLogin } from "react-google-login";
import { serviceProviderLogin } from "../apis";
import _ from "lodash";

const ServiceProviderLogin = () => {
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [res, setRes] = useState({});

  const navigate = useNavigate();
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/serviceProviderLogin");
    } else {
      navigate("/");
    }
  }, []);

  const LoginButtonHandler = async () => {
    const data = await serviceProviderLogin({
      email: enteredEmail,
      password: enteredPassword,
    });
    setRes(data.data);
  };

  useEffect(() => {
    if (res.success == true) {
      localStorage.setItem("user-info", JSON.stringify(res.userInfo));
      localStorage.setItem("user-type", "service provider");
      if (res.userInfo.isActive == false && res.userInfo.infoFilled == false) {
        navigate("/service-provider/info");
      } else if (
        res.userInfo.isActive == false &&
        res.userInfo.infoFilled == true
      ) {
        navigate("/service-provider/under-review");
      } else {
        navigate("/feeds");
      }
    }
  }, [res]);

  const onSuccessGoogle = (res) => {
    console.log("User successfully loggedIn! user:", res.profileObj);
    localStorage.setItem("user-info", JSON.stringify(res.profileObj));
    navigate("/create-request");
  };

  const onFailureGoogle = (res) => {
    console.log("Login Failed res: ", res);
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="sm">
        <Box>
          <Grid container spacing={2}>
            <span>
              <h3 className="ml-9">Service Provider Log In</h3>
              <p className="ml-9">Please create an account and stay updated.</p>
            </span>
            <div className="login-form">
              <TextField
                required
                size="small"
                id="outlined-basic"
                label="Email Address"
                variant="outlined"
                onChange={(e) => setEnteredEmail(e.target.value)}
              />
              {!res.success ? (
                <span className="mt-3" style={{ color: "red" }}>
                  {res.message}
                </span>
              ) : null}
              <TextField
                required
                size="small"
                id="outlined-basic"
                label="Password"
                variant="outlined"
                type="password"
                className="mt-13"
                onChange={(e) => setEnteredPassword(e.target.value)}
              />
              {!res.success ? (
                <span className="mt-3" style={{ color: "red" }}>
                  {res.message}
                </span>
              ) : null}

              <span className="text-align-center">
                <Button
                  variant="contained"
                  onClick={LoginButtonHandler}
                  className="mt-13 w-43"
                >
                  Login
                </Button>
              </span>

              <span className="text-align-center mt-8 mb-8">OR</span>
              <span className="text-align-center mb-6">
                <GoogleLogin
                  clientId="469270145255-938kdgrj0kb2ikjs4ef9sqdbm1bi8omo.apps.googleusercontent.com"
                  buttonText="Sign in with Google"
                  onSuccess={onSuccessGoogle}
                  onFailure={onFailureGoogle}
                  cookiePolicy={"single_host_origin"}
                />
              </span>
              <span className="text-align-center mb-6">
                Don't have an account?{" "}
                <Link
                  to="/serviceProviderRegister"
                  className="text-decoration-none text-bold"
                >
                  Register Here
                </Link>
              </span>
            </div>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default ServiceProviderLogin;
